export function fileUploadErrorMessage(
  error: unknown,
  options: { localDemo: boolean },
): string {
  const code =
    typeof error === "object" && error !== null && "code" in error
      ? String(error.code)
      : "";

  if (code === "storage/unauthorized") {
    return "The file was not uploaded, and the incomplete file was removed. Try again. If this keeps happening, contact support.";
  }
  if (code === "storage/canceled") {
    return "The image upload was canceled. Paste the image again when you are ready.";
  }
  if (code === "storage/invalid-checksum") {
    return "The uploaded image did not arrive intact. Paste the image again.";
  }
  if (
    options.localDemo &&
    [
      "storage/unknown",
      "storage/retry-limit-exceeded",
      "storage/server-file-wrong-size",
    ].includes(code)
  ) {
    return "Secure file storage is not running in the local demo. Restart the complete demo with npm run demo, then try again.";
  }
  return "The file bytes could not be uploaded. Check your connection, then try again.";
}
